import { SOCKET_EVENTS } from "./Events";

export const getAllUsersInScene = (currentUsers, sceneId) => {
  const usersInScene = [];
  Object.keys(currentUsers).forEach(key => {
    if ((currentUsers[key].sceneId === sceneId) || (currentUsers[key].currentSceneId === sceneId)) {
      usersInScene.push(currentUsers[key]);
    }
  });
  return usersInScene;
}

export const tourExists = (tourId, tourData) => {
  if (tourData && Object.keys(tourData).length > 0) {
    return tourData;
  }
  return false;
}

export const joinedTourUserIds = (tourId, tourData) => {
  if (!tourExists(tourId, tourData)) {
    return [];
  }
  return tourData[tourId].users;
}

export const guestsJoinedTourIds = (tourId, tourData) => {
  if (!tourExists(tourId, tourData)) {
    return [];
  }
  return tourData[tourId].guests;
}

export const tourPeople = (users) => {
  let people = [];
  const objectsWithUserId = Object.values(users).filter(obj => obj && obj.hasOwnProperty('userId'));
  objectsWithUserId.forEach(item => {
    if (item && item.hasOwnProperty("tourName") || item.guest || item.tourContributore) {
      people.push(item)
    }
  })
  return people;
}

export const newTourPeople = (users, tourGuests, ownerId) => {
  console.log("newTourPeople", users, tourGuests)
  const owner = users.filter(user => user.socketId === ownerId);
  const filteredUsers = users.filter(function (user) {
    return tourGuests.includes(user.socketId || ownerId);
  });
  return [...filteredUsers, ...owner];
}

export const tourGuests = (users) => {
  const tourGuests = [];
  const objectsWithUserId = Object.values(users).filter(obj => obj && obj.hasOwnProperty('userId'));
  objectsWithUserId.forEach(item => {
    if (item && item.tourGuest) {
      tourGuests.push(item)
    }
  })
  return tourGuests;
}

/**
 * 
 * @param {Array} users 
 * @returns array of users for checkbox/switch UI selection
 */
export const usersToSelection = (users, model) => {
  const userId = model.config.userId;
  users = users.filter(user => user && user.userId !== userId);
  users.map(user => {
    user.id = user.userId;
    user.selected = true;
    user.name = user.userName;
    return user;
  })
  return users;
}

/**
 * 
 * @param {Array} users 
 * @returns array of users who are on tour including guide
 */
export const getTourPeople = (users) => {
  return users.filter(user => user.tourName)
}


export const findKeyByValue = (obj, value) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] === value) {
      return key;
    }
  }
  return null; // Return null if the value is not found in the object
}
export const findTourGuestByStreamId = (users, _streamId) => {
  return users.find(user => user.tourGuest && (user.tourGuest === _streamId));
}
export const findUserBySocektId = (users, _streamId) => {
  return users.find(user => user.socketId && (user.socketId === _streamId));
}

export const isSingleStreamOwner = (tourData) => {
  if (tourData && tourData.streams) {
    const streamKeys = Object.keys(tourData.streams);

    // Check if there is only one stream
    if (streamKeys.length === 1) {
      // Check if the single stream's key is the owner
      return tourData.owner === streamKeys[0];
    }
  }
  return false;
}


export const hashString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

const socketIds = [];

/**
 * @param Socket socket
 * @param Model model
 * = null: other than world/view
 * != null: is at world/view
 */
export const handleRestriction = (socket, model = null, handleDisconnect = () => {}) => {
  if (!socket) {
    return;
  }

  if (model?.isEmbed) {
    return;
  }

  if (socket?.initialized) {
    socket.emit("opened_session");
  }
  socket.on('initialized', () => {
    socketIds.push(socket.id);
    socket.emit("opened_session");
  })

  socket.on("freeze_session", (data) => {
    const $restrictionModal = $("#restrictionModal");

    // freeze by active another browser, should close all connections to socket and ant media
    if (data.eventName === 'resume_session') {
      if (model?.view) {
        model.view.standUpFromChair?.()
        model.view.standUpFromScreenShare?.()
        model.view.render3DWorld = false

        $restrictionModal.find('.restrict-modal-content__content-on-disabled').show()
        $restrictionModal.find('.restrict-modal-content__content-on-load').hide()
        $restrictionModal.find('.restrict-modal-content__continue-on-disabled').show()
        $restrictionModal.find('.restrict-modal-content__continue-on-load').hide()
      }
    }

    if (!data.activeSessionId || !socketIds.includes(data.activeSessionId)) {
      $restrictionModal.show();

      model?.dispatchEvent({ type: SOCKET_EVENTS.FREEZE_SESSION, data });

      model?.socket?.forceDisconnect()
      handleDisconnect()
    }
  });

  $("#resumeThisSession").on('click', () => {
    if (socket.disconnected) {
      socket.removeAllListeners("connect");
      socket.on('initialized', () => {
        socket.emit("resume_session");
        window.location.reload();
      })
      socket.connect();
    } else {
      $("#restrictionModal").hide();

      socket.emit("resume_session");

      model?.dispatchEvent({ type: SOCKET_EVENTS.RESUME_SESSION });
    }
  });
};
